<div class="banner-background relative pt-7">
  <div class="banner-container py-0 lg:pt-28">
    <h1 class="banner-title m-0 flex flex-col lg:mb-5">
      <ng-container *ngIf="(isLoggedIn$ | async) && (userInfo$ | async)">
        <span> {{ personalizationMessage$ | async }} </span>
        <span> {{ welcomeMessage$ | async }} </span>
      </ng-container>

      <ng-container *ngIf="!(isLoggedIn$ | async)">
        <span> {{ 'homepage.banner_title' | translate }} </span>
      </ng-container>
    </h1>
    <p class="banner-subtitle m-0">
      {{ 'homepage.banner_subtitle' | translate }}
    </p>
  </div>
  <rd-banner-image [bannerImageConfig]="bannerImageConfig"></rd-banner-image>
</div>
